const checkNutriScore = (value: string): string | null => {
    const nutriScores = ["A", "B", "C", "D", "E"];
    if (!value || !nutriScores.includes(value.toUpperCase())) {
        return null;
    }
    return value;
};

const matomoPush = (values: any[]) => {
    if (!values.length) {
        return;
    }
    const noTrackPageViewActions = ["trackEvent", "trackSiteSearch"];
    let trackPage = true;
    var _paq: any[] = ((window as any)._paq = (window as any)._paq || []);

    for (let i = 0; i < values.length; i++) {
        if (values[i].length && noTrackPageViewActions.includes(values[i][0])) {
            trackPage = false;
        }

        _paq.push(values[i]);
    }

    if (trackPage) {
        _paq.push(["trackPageView"]);
    }
};

export { checkNutriScore, matomoPush };
